import React from 'react';
import UL from './UL';
import LI from './LI';
import Icon from './Icon';
import Button from './Button';

export default () => (
  <UL inverse inline>
    <LI inline>
      <Button
        link
        bordered
        inverse
        circle
        target="_blank"
        rel="noopener"
        href="https://github.com/gautiselvaraj"
        title="Gowtham Selvaraj's Github Account"
      >
        <Icon big github aria-label="Gowtham Selvaraj's Github Account" />
      </Button>
    </LI>
    <LI inline>
      <Button
        link
        bordered
        inverse
        circle
        target="_blank"
        rel="noopener"
        href="https://www.linkedin.com/in/gautiselvaraj/"
        title="Gowtham Selvaraj's LinkedIn Page"
      >
        <Icon big linkedin aria-label="Gowtham Selvaraj's LinkedIn Page" />
      </Button>
    </LI>
    <LI inline>
      <Button
        link
        bordered
        inverse
        circle
        target="_blank"
        rel="noopener"
        href="https://twitter.com/gautiselvaraj"
        title="Gowtham Selvaraj's Twitter Account"
      >
        <Icon big twitter aria-label="Gowtham Selvaraj's Twitter Account" />
      </Button>
    </LI>
  </UL>
);



// WEBPACK FOOTER //
// ./src/components/SocialLinks.js